import { render } from "./BlogBanner.vue?vue&type=template&id=47999e88&scoped=true"
import script from "./BlogBanner.vue?vue&type=script&lang=js"
export * from "./BlogBanner.vue?vue&type=script&lang=js"

import "./BlogBanner.vue?vue&type=style&index=0&id=47999e88&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47999e88"]])

export default __exports__